import type { QuestaoRevisada } from "../../types"
import { letra } from "../../lib/format"
import { Card, Selo } from "../ui"

/**
 * Uma questão revisada: enunciado, alternativas com o certo e o marcado,
 * comentário e fonte. É o mesmo card na demonstração, na lista "ver mais" e no
 * gabarito de quem já pagou — a pessoa aprende a ler um formato só.
 */
export function QuestaoRevisadaCard({ q }: { q: QuestaoRevisada }) {
  return (
    <Card>
      <div className="flex items-center justify-between gap-3">
        <span className="text-xs font-semibold text-slate-500">
          {q.posicao}. {q.unidade.codigo} · {q.topico}
        </span>
        {q.correta ? (
          <Selo tom="ok">Acertou</Selo>
        ) : (
          <Selo tom="erro">{q.resposta_dada === null ? "Em branco" : "Errou"}</Selo>
        )}
      </div>

      <p className="mt-3 text-sm leading-relaxed text-navy-900">{q.enunciado}</p>

      <ul className="mt-3 space-y-1.5">
        {q.alternativas.map((alternativa, i) => {
          const correta = i === q.indice_correto
          const marcada = i === q.resposta_dada
          return (
            <li
              key={i}
              className={`flex gap-2 rounded-lg border p-2.5 text-sm ${
                correta
                  ? "border-emerald-300 bg-emerald-50 text-emerald-900"
                  : marcada
                    ? "border-red-300 bg-red-50 text-red-900"
                    : "border-transparent text-slate-600"
              }`}
            >
              <span className="font-bold">{letra(i)}</span>
              <span>{alternativa}</span>
            </li>
          )
        })}
      </ul>

      {q.comentario && (
        <div className="mt-3 rounded-xl bg-navy-50 p-3">
          <p className="text-sm text-navy-900">{q.comentario}</p>
          {q.fonte && (
            <p className="mt-2 text-xs font-semibold text-navy-700">
              Fonte: {q.fonte}
              {q.dispositivo ? ` · ${q.dispositivo}` : ""}
            </p>
          )}
        </div>
      )}
    </Card>
  )
}
